import { createClient } from '@supabase/supabase-js';
import { getSupabaseConfig } from '../config/config';

const { url: supabaseUrl, anonKey: supabaseKey } = getSupabaseConfig();

// Define client IDs
export const MAIN_CLIENT_ID = 'main-client';
export const SERVICE_CLIENT_ID = 'service-client';

// Set client ID in localStorage for tracking
localStorage.setItem('supabase.client-id', MAIN_CLIENT_ID);

// Create main client with anon key
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storageKey: `supabase.auth.token.${MAIN_CLIENT_ID}`
  }
});

// Create service client with service key and separate storage
export const createClientWithServiceKey = (serviceKey: string) => {
  // Set client ID before creating the service client
  localStorage.setItem('supabase.client-id', SERVICE_CLIENT_ID);

  // Create client with different storage key
  const serviceClient = createClient(supabaseUrl, serviceKey, {
    auth: {
      storageKey: `supabase.auth.token.${SERVICE_CLIENT_ID}`
    }
  });

  // Reset client ID to main after creating the service client
  localStorage.setItem('supabase.client-id', MAIN_CLIENT_ID);

  return serviceClient;
};
